import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { PersistGate } from "redux-persist/integration/react";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { ThemeProvider } from "@mui/material";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import store, { persistor } from "./store";
import "./i18n";
import theme from "./styles/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <ThemeProvider theme={theme}>
              <SnackbarProvider>
                <App />
              </SnackbarProvider>
            </ThemeProvider>
          </BrowserRouter>
        </PersistGate>
      </Suspense>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
